module.exports = __webpack_public_path__ + "img/9.55feef4d.jpg";